import { render } from "./App.vue?vue&type=template&id=6f791b39&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=6f791b39&lang=css"
script.render = render
script.__scopeId = "data-v-6f791b39"

export default script